import { Component } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { NgIf, NgFor } from '@angular/common';
import { MatOption } from '@angular/material/core';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-create-variant-key-dialog',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    MatFormFieldModule,
    FormsModule,
    MatFormField,
    MatInput,
    MatSelect,
    MatOption,
    MatButton,
    MatIcon,
    MatIconModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions
  ],
  templateUrl: './create-variant-key-dialog.component.html'
})
export class CreateVariantKeyDialogComponent {

  key_code = '';
  display_name = '';

  constructor(private dialogRef: MatDialogRef<CreateVariantKeyDialogComponent>) { }

  save() {
    this.dialogRef.close({
      key_code: this.key_code.trim(),
      display_name: this.display_name.trim()
    });
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
